import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
interface ReviewProps {
  author: string;
  location: string;
  content: string;
  timeAgo: string;
}
export function Review({
  author,
  location,
  content,
  timeAgo
}: ReviewProps) {
  return <div className="border-b border-gray-100 py-4 last:border-0" data-id="element-102">
      <div className="flex items-center mb-2" data-id="element-103">
        <div className="flex text-yellow-400" data-id="element-104">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current" data-id="element-105" />)}
        </div>
        <span className="text-xs text-blue-600 ml-2 font-medium" data-id="element-106">{author}</span>
        <span className="text-xs text-gray-400 ml-1" data-id="element-107">from {location}</span>
      </div>
      <p className="text-xs text-gray-600 mb-2 leading-relaxed" data-id="element-108">{content}</p>
      <div className="flex items-center justify-between" data-id="element-109">
        <span className="text-[10px] text-gray-400" data-id="element-110">{timeAgo}</span>
        <div className="flex items-center text-gray-500 text-[10px]" data-id="element-111">
          <CheckCircle className="w-3 h-3 mr-1 text-blue-500" data-id="element-112" />
          Verified Review
        </div>
      </div>
    </div>;
}